// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AttachmentError {
  export class FileTooBig {
    public readonly kind = 'FileTooBig'
    constructor(readonly file: File) {}
  }
  export class InvalidExtension {
    public readonly kind = 'InvalidExtension'
    constructor(readonly file: File) {}
  }
  export class InvalidMimeType {
    public readonly kind = 'InvalidMimeType'
    constructor(readonly file: File) {}
  }
  export class MissingExtension {
    public readonly kind = 'MissingExtension'
    constructor(readonly file: File) {}
  }

  export class MissingVersion {
    public readonly kind = 'MissingVersion'
    constructor(readonly file: File) {}
  }
  export class Unknown {
    public readonly kind = 'Unknown'
    constructor(
      readonly file: File,
      readonly cause: any
    ) {}
  }

  export class PublishFailure {
    public readonly kind = 'PublishFailure'
    constructor(readonly cause: any) {}
  }

  export type Type =
    | FileTooBig
    | InvalidExtension
    | InvalidMimeType
    | MissingExtension
    | MissingVersion
    | Unknown
    | PublishFailure
}
